// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import LoadingBar from 'react-redux-loading-bar'

// Internal Dependencies:
import AccountMenu from './AccountMenu'
import HeaderNotifications from './HeaderNotifications'

class Header extends React.Component {
	render() {
		return (
			<header className="site-header">
				<LoadingBar className="header-loading-bar" updateTime={ 100 } maxProgress={ 90 } progressIncrease={ 10 } />

				<div className="-inner">
					<div className="-content">
						<div className="-logo">
							<a href="https://comfortsleep.com.au/">
								<img src={ `${siteData.images_url}svg/logo.svg` } alt={ siteData.site_name } />
							</a>
						</div>

						<HeaderNotifications />
						<AccountMenu />
					</div>
				</div>
			</header>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps )( Header )
